import { render, staticRenderFns } from "./search-input.component.vue?vue&type=template&id=bdfbac3c"
import script from "./search-input.component.vue?vue&type=script&lang=ts"
export * from "./search-input.component.vue?vue&type=script&lang=ts"
import style0 from "./search-input.component.vue?vue&type=style&index=0&id=bdfbac3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports